/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-restricted-globals */
import React, { FC, useCallback, useState } from 'react';
import { useEvent } from 'react-use';
import { CookieContext } from './CookieContext';
import { getCookieConsent } from './cookie.utils';
import { CookieCategories } from './cookies.types';

function updateGoogleConsent(
  config: { gtag?: string; gtm?: string },
  categories: CookieCategories[],
) {
  if (typeof window === 'undefined') {
    return;
  }

  const hasGoogleAnalytics = categories.includes(CookieCategories.GOOGLE_ANALYTICS);
  const hasMarketing = categories.includes(CookieCategories.MARKETING);

  const consentUpdate: Record<string, 'granted' | 'denied'> = {
    analytics_storage: hasGoogleAnalytics ? 'granted' : 'denied',
    ad_storage: hasMarketing ? 'granted' : 'denied',
    ad_user_data: hasMarketing ? 'granted' : 'denied',
    ad_personalization: hasMarketing ? 'granted' : 'denied',
  };

  // GTM mode: push consent update to dataLayer
  if (config.gtm && Array.isArray((window as any).dataLayer)) {
    (window as any).dataLayer.push({
      event: 'consent_update',
      ...consentUpdate,
    });
  }

  // gtag mode: use gtag function if available
  if ((window as any).gtag) {
    (window as any).gtag('consent', 'update', consentUpdate);

    if (config.gtag && hasGoogleAnalytics) {
      (window as any).gtag('config', config.gtag);
    }
  }
}

// eslint-disable-next-line react/no-unused-prop-types
const CookieContextProvider: FC<{ lang: string; eventId: string; children: any }> = ({
  eventId,
  children,
}) => {
  // eslint-disable-next-line no-restricted-globals
  const { cookieBanner } = window.__DATA__;
  const [, setState] = useState(0);
  const refreshCookies = useCallback(() => setState(Date.now()), [setState]);
  useEvent('cc:onConsent', refreshCookies);
  useEvent('cc:onChange', refreshCookies);

  const { categories } = getCookieConsent(eventId);

  updateGoogleConsent({ gtag: cookieBanner?.gtag, gtm: cookieBanner?.gtm }, categories);

  return (
    <CookieContext.Provider value={{ hasCookieBanner: !!cookieBanner?.enabled, categories }}>
      {children}
    </CookieContext.Provider>
  );
};

export default CookieContextProvider;
